<template>
  <div v-if="score">
    <ScoreboardWithPoint v-if="isProcessGroup" :scoreGroup="score" />
    <div v-else class="b-portlet">
      <div class="b-portlet-body">
        <Scoreboard
          :data="score"
          @showTextReport="showTextReport"
          :textReportActive="textReportActive"
        ></Scoreboard>
      </div>
    </div>
  </div>
</template>

<script>
import Scoreboard from '../report/scoreboard/Scoreboard.vue'
import ScoreboardWithPoint from '../report/ScoreboardWithPoint.vue'

export default {
  components: {
    Scoreboard,
    ScoreboardWithPoint
  },
  props: ['score', 'textReportActive', 'isProcessGroup'],
  methods: {
    showTextReport (showStatus) {
      if (showStatus) {
        this.$emit('next')
      } else {
        this.$emit('skip', 3)
      }
    }
  }
}
</script>
